/****************************************************
 * Module Name:  addMixClarityModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import CircularProgress from "@mui/material/CircularProgress";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import MixClarityProxy from "../../utility/proxy/manager/mixProxy/mixClarityProxy";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';

export default class AddMixClarityModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newclarity: this.props.editOperation ? this.props.sourceData.name : "",
      newclarityfullname: this.props.editOperation
        ? this.props.sourceData.fullname
        : "",
      newdescription: this.props.editOperation
        ? this.props.sourceData.description
        : "",

      showError: false,

      validateClarityPresentSpinner: false,
      showValidationMessage: false,
      clarityAvailable: true,

      clarityValidationError: "",
      fullNameValidationError: "",
      newseq: this.props.editOperation ? this.props.sourceData.seq : "",
    };
  }

  handleSave = () => {
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      name: this.state.newclarity,
      fullname: this.state.newclarityfullname,
      description: this.state.newdescription,
      seq: this.state.newseq
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateClarityPresent = (clarityEntered) => {
    if (!clarityEntered || clarityEntered.trim() === "") return;

    this.setState({
      validateClarityPresentSpinner: true,
    });

    MixClarityProxy.CheckClarityAvailable(clarityEntered, (response) => {
      //if we got response that means clarity is present at backend
      if (response) {
        //ClarityName already present
        this.setState({
          validateClarityPresentSpinner: false,
          showValidationMessage: true,
          clarityAvailable: false,
        });
      } else {
        //ClarityName not available, so can be used
        this.setState({
          validateClarityPresentSpinner: false,
          showValidationMessage: true,
          clarityAvailable: true,
        });
      }
    });
  };

  buttonDisable = () => {
    if (!this.props.editOperation)
      return !this.state.showValidationMessage || !this.state.clarityAvailable;

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add clarity validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation ? "Edit Clarity" : "Add New Clarity"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  {this.props.editOperation && (
                    <tr>
                      <td>
                        <Form.Label>Clarity Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.sourceData.id}</Form.Label>
                      </td>
                    </tr>
                  )}
                  {this.props.editOperation && (
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <Form.Label>
                        Clarity <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    {this.props.editOperation ? (
                      <td>
                        <Form.Label>{this.state.newclarity.trim()}</Form.Label>
                      </td>
                    ) : (
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="Clarity (required)"
                          placeholder="Enter Clarity"
                          value={this.state.newclarity}
                          autoFocus
                          onBlur={(e) =>
                            this.validateClarityPresent(this.state.newclarity.trim())
                          }
                          onChange={(e) =>
                            this.setState({
                              newclarity: e.target.value.trim(),
                              showValidationMessage: false,
                              clarityValidationError: Utility.CheckIsPresent(
                                e.target.value
                              )
                                ? ""
                                : "Clarity Cannot be Empty",
                            })
                          }
                          helperText={this.state.clarityValidationError}
                          error={this.state.clarityValidationError.length > 0}
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      {this.state.validateClarityPresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box>&nbsp;</Box>
                      ) : this.state.clarityAvailable ? (
                        <font color="green">Clarity available</font>
                      ) : (
                        <font color="red">Clarity not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Description</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Description"
                        placeholder="Enter Description"
                        value={this.state.newdescription}
                        onChange={(e) =>
                          this.setState({ newdescription: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Sequence</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Sequence"
                        placeholder="Enter Sequence"
                        value={this.state.newseq}
                        onChange={(e) =>
                          this.setState({ newseq: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
